<button
  (click)="button_click.emit()"
  mat-icon-button
  [ngClass]="button_class">
  <mat-icon [ngClass]="icon_class"> {{ icon }} </mat-icon>
</button>
